<template>
    <div class="border rounded-lg w-full mb-4 p-4">
        <p class="text-gray-700 dark:text-gray-200 mb-4">Options</p>

        <Select
            label="List"
            name="listAll"
            v-model="options.listAll"
            class="mt-2"
            :options="[
                {value: '1', name: 'List All'},
                {value: '0', name: 'Customize Selection'},
            ]"
        />

        <Select
            label="Display"
            name="displayAll"
            v-model="options.displayAll"
            :disabled="options.listAll == 1"
            class="mt-2"
            :options="[
                {value: '1', name: 'All Payment Methods'},
                {value: '0', name: 'Payment Methods with Pages'},
            ]"
        />

        <Select
            label="Order"
            name="listOrder"
            v-model="options.listOrder"
            :disabled="options.listAll == 1"
            class="mt-2"
            :options="[
                {value: 'usage', name: 'Most Popular'},
                {value: 'alphabetical', name: 'Alphabetical Order'},
            ]"
        />

        <input-text
            label="Open Display Limit"
            name="open_display_limit"
            v-model="options.openDisplayLimit"
            :disabled="options.listAll == 1"
            class="mt-3"
            type="number"
        />

        <input-text
            label="List Limit"
            name="list_limit"
            v-model="options.listLimit"
            :disabled="options.listAll == 1"
            class="mt-3"
            type="number"
        />

        <input-checkbox
            v-if="isPaymentCategoryPage"
            label="Exclude Associated Payment Method"
            name="exclude_associated_payment_method"
            v-model="options.excludeAssociatedPaymentMethod"
            :disabled="options.listAll == 1"
            class="mt-3"
        />

        <Btn
            class="mt-3"
            :class="{ 'bg-red-600': isDirty }"
            type="button"
            content="Apply Options"
            @click="emitOptions"
        />
        <div v-if="isDirty">
            <small class="text-red-400">* You need to click the button to reload the list</small>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "TableWithBigListOptions",
    components: { draggable },
    props: {
        model: {
            type: String,
            required: true,
        },
        languageId: {
            type: Number,
            required: true,
        },
        isPaymentCategoryPage: {
            type: Boolean,
            default: false,
        },
        paymentMethodId: {
            type: Number,
            required: false,
        },
        value: Object,
        contentBlockIndex: Number,
    },
    data() {
        return {
            isDirty: false,
            options: {
                ...this.value,
                paymentMethodId: this.paymentMethodId,
                isPaymentCategoryPage: this.isPaymentCategoryPage
            },
        };
    },
    methods: {
        emitOptions () {
            this.$emit('input', this.options);
            this.options = {...this.options};
        }
    },
    watch: {
        options: {
            handler (newValue) {
                newValue = JSON.stringify(newValue);
                let propValue = JSON.stringify(this.value);

                if (newValue !== propValue) {
                    this.isDirty = true;
                }
                else {
                    this.isDirty = false;
                }
            },
            deep: true,
        },
    },
};
</script>
